import api from '../base';
import {
  mockBaseMarketplaces, mockImportValidationError, mockPricingRuleTemplate,
} from './pricingRulesMocks';

const PRICING_RULES_BASE_PATH = 'management/products/pricing-rules';
export const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export async function getBaseMarketplaces(signal?: AbortSignal): Promise<string[]> {
  const response = await api.get<string[]>(
    `${PRICING_RULES_BASE_PATH}/base-marketplaces`,
    { signal },
  );

  return response.data;
}

api.mock
  .onGet(`${PRICING_RULES_BASE_PATH}/base-marketplaces`)
  .reply(() => [
    200,
    Math.random() < 0.5 ? mockBaseMarketplaces : mockBaseMarketplaces.slice(0, 1),
  ]);

export async function downloadPricingRuleTemplate(baseMarketplaceCode: string): Promise<Blob> {
  const response = await api.get<Blob>(`${PRICING_RULES_BASE_PATH}/template`, {
    params: { baseMarketplaceCode },
    responseType: 'blob',
  });

  return response.data;
}

api.mock
  .onGet(`${PRICING_RULES_BASE_PATH}/template`)
  .reply(200, mockPricingRuleTemplate, { 'Content-Type': XLSX_MIME_TYPE });

export async function importPricingRules(
  baseMarketplaceCode: string,
  file: FormData,
): Promise<void> {
  const response = await api.post<void>(`${PRICING_RULES_BASE_PATH}/import`, file, {
    headers: { 'Content-Type': 'multipart/form-data' },
    params: { baseMarketplaceCode },
  });

  return response.data;
}

api.mock.onPost(`${PRICING_RULES_BASE_PATH}/import`).reply(() => {
  if (Math.random() < 0.5) {
    return [400, mockImportValidationError];
  }

  return [200];
});
